<ng-container [formGroup]="controlContainer.control">
    <input
        wdxInputText
        [type]="conditionalType"
        [formControlName]="formControlObj"
        max="9999-12-31"
        [attr.data-cy]="cySelector"
    />
</ng-container>
